import React from 'react';
import { useMandatoryPathParam } from '../../core/routing/hooks/use-mandatory-path-param';
import { RouteParam } from '../../core/routing/param';
import { ThreeDModel } from '../../modules/article-preview/three-d-model';

/**
 * Offline Rendering Page
 * @constructor
 */
export const Overview: React.FC = () => {
  const articleId = useMandatoryPathParam(RouteParam.articleId);
  return <ThreeDModel detail={null} modelId={articleId} />;
};
